var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo09(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M931.3 659.4H87.4V192.3c0-33.5 27.2-60.7 60.7-60.7h722.6c33.5 0 60.7 27.2 60.7 60.7v467.1z",
    fill: "#e5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.3 672.4H87.4c-7.2 0-13-5.8-13-13V192.3c0-40.6 33-73.7 73.7-73.7h722.6c40.6 0 73.7 33 73.7 73.7v467.1c-0.1 7.2-5.9 13-13.1 13z m-830.9-26h817.9V192.3c0-26.3-21.4-47.7-47.7-47.7H148.1c-26.3 0-47.7 21.4-47.7 47.7v454.1z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.6 762.2H148.1c-33.5 0-60.7-27.2-60.7-60.7v-50h843.9v50c0 33.6-27.2 60.7-60.7 60.7z",
    fill: "#8fc6f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.6 775.2H148.1c-40.6 0-73.7-33-73.7-73.7v-63h869.9v63c0 40.7-33 73.7-73.7 73.7zM100.4 664.6v37c0 26.3 21.4 47.7 47.7 47.7h722.6c26.3 0 47.7-21.4 47.7-47.7v-37h-818z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.4 700.3m-26.5 0a26.5 26.5 0 1 0 53 0 26.5 26.5 0 1 0-53 0Z",
    fill: "#e5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 353.4m-102.5 0a102.5 102.5 0 1 0 205 0 102.5 102.5 0 1 0-205 0Z",
    fill: "#e5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 468.9c-63.7 0-115.5-51.8-115.5-115.5s51.8-115.5 115.5-115.5S461 289.7 461 353.4s-51.7 115.5-115.5 115.5z m0-205.1c-49.4 0-89.5 40.2-89.5 89.5s40.2 89.5 89.5 89.5 89.5-40.2 89.5-89.5-40.1-89.5-89.5-89.5z",
    fill: "#8fc6f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 353.4m-28.3 0a28.3 28.3 0 1 0 56.6 0 28.3 28.3 0 1 0-56.6 0Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.2 353.4m-102.5 0a102.5 102.5 0 1 0 205 0 102.5 102.5 0 1 0-205 0Z",
    fill: "#e5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.2 468.9c-63.7 0-115.5-51.8-115.5-115.5s51.8-115.5 115.5-115.5 115.5 51.8 115.5 115.5-51.8 115.5-115.5 115.5z m0-205.1c-49.4 0-89.5 40.2-89.5 89.5s40.2 89.5 89.5 89.5 89.5-40.2 89.5-89.5-40.2-89.5-89.5-89.5z",
    fill: "#8fc6f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.2 353.4m-28.3 0a28.3 28.3 0 1 0 56.6 0 28.3 28.3 0 1 0-56.6 0Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.9 465.6c0 28.3-23.2 51.5-51.5 51.5s-51.5-23.2-51.5-51.5",
    fill: "#e5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.4 530.2c-35.6 0-64.5-29-64.5-64.5 0-7.2 5.8-13 13-13s13 5.8 13 13c0 21.3 17.3 38.5 38.5 38.5 21.3 0 38.5-17.3 38.5-38.5 0-7.2 5.8-13 13-13s13 5.8 13 13c0 35.5-29 64.5-64.5 64.5z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.6 762.2h171.5v89.6H423.6z",
    fill: "#e5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.1 864.8H423.6c-7.2 0-13-5.8-13-13v-89.6c0-7.2 5.8-13 13-13h171.5c7.2 0 13 5.8 13 13v89.6c0 7.2-5.8 13-13 13z m-158.5-26h145.5v-63.6H436.6v63.6z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.3 898.9H351.4c-18.8 0-34.2-15.4-34.2-34.2 0-18.8 15.4-34.2 34.2-34.2h315.8c18.8 0 34.2 15.4 34.2 34.2 0 18.9-15.3 34.2-34.1 34.2z",
    fill: "#e5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.3 911.9H351.4c-26 0-47.2-21.2-47.2-47.2s21.2-47.2 47.2-47.2h315.8c26 0 47.2 21.2 47.2 47.2s-21.1 47.2-47.1 47.2z m-315.9-68.3c-11.7 0-21.2 9.5-21.2 21.2s9.5 21.2 21.2 21.2h315.8c11.7 0 21.2-9.5 21.2-21.2s-9.5-21.2-21.2-21.2H351.4z",
    fill: "#141414"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo09);
export default __webpack_public_path__ + "static/media/logo09.98bedb58ea96ae0e25b37c8fd67986f5.svg";
export { ForwardRef as ReactComponent };